import { render, staticRenderFns } from "./rightYz.vue?vue&type=template&id=bdcc6e24&scoped=true&"
import script from "./rightYz.vue?vue&type=script&lang=js&"
export * from "./rightYz.vue?vue&type=script&lang=js&"
import style0 from "./rightYz.vue?vue&type=style&index=0&id=bdcc6e24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc6e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdcc6e24')) {
      api.createRecord('bdcc6e24', component.options)
    } else {
      api.reload('bdcc6e24', component.options)
    }
    module.hot.accept("./rightYz.vue?vue&type=template&id=bdcc6e24&scoped=true&", function () {
      api.rerender('bdcc6e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xmy/drawer/rightBar/rightYz.vue"
export default component.exports